import { deleteGLEntity } from "../../../../../actions/Utilities/GLEntity";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteGLEntity = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteGLEntity(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetGLEntitys"]);
      toast.fire(
        "Success",
        "GL Entity has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate GL Entitys",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteGLEntity;
